import React from 'react'

let Loader = () => {
    return   <div id="loading">
<div className="loader simple-loader">
    <div className="loader-body"></div>
</div>    </div>
}

export default Loader;